const createUserSlice = (set, get) => ({
  user: {
    isProfileIncomplete: true,
    isProfileLoading: true,
    alertMessage:
      'Join the movement for positive change: Upgrade before your pilot period expires on ',
    profile: {
      id: -1,
      firstName: '',
      lastName: '',
      fullName: '',
      designation: '',
      profileUrl: '',
      email: '',
      dob: '',
      auth0_id: '',
      address: null,
      linkedinProfile: null,
      facebookProfile: null,
      twitterProfile: null,
      instagramProfile: null,
      phoneNumber: '',
      profileVisible: false,
      skillsVisible: false,
      causesVisible: false,
      contactInformationVisible: false,
      causesSupportedVisible: false,
      locationVisible: false,
      tAndCTimestamp: null,
      zipCode: null,
      about: '',
      points: 0,
      badges: [],
      badgesCount: 0,
      avatar: '',
      bannerImage: '',
      skills: [],
      causes: [],
      following: {
        influencers: [],
        nonprofits: [],
        nonprofitsDetails: [],
      },
      numFollowers: 0,
      notificationPreferences: {
        newPosts: true,
        commentsOnYourPosts: true,
        commentsOnAPostYouHaveCommentedOn: true,
        postReactions: true,
        youAreMentionedOnAPost: true,
        newFollower: true,
        communityDigestEmail: true,
        newsletterEmail: true,
      },
      companyId: -1,
      activeCommunityId: -1,
      currentLevelId: -1,
      companyName: null,
      locationDetails: null,
      country: null,
      activeCommunity: {
        id: -1,
        name: '',
        address: '',
        logoUrl: '',
        type: '',
        numLicenses: -1,
        orgType: '',
        createdAt: null,
        updatedAt: null,
        planId: -1,
        appPreferences: {
          id: -1,
          showOnlyPreferredNonProfits: false,
          // hideForeignNonProfits: false,
        },
        communityId: -1,
        role: '',
        updatedBy: -1,
        userId: -1,
        locationId: -1,
        reward: {
          levels: [{ index: 1, name: '', points: 1 }],
        },
        subscription: {
          plan: {
            allowedFeatures: [],
            blockedFeatures: [],
          },
        },
      },
      company: {
        id: -1,
        name: '',
        logoUrl: '',
        role: '',
        location: '',
        locationId: -1,
        appPreferences: {
          showOnlyPreferredNonProfits: false,
          // hideForeignNonProfits: false,
        },
        reward: {
          levels: [{ index: 1, name: '', points: 1 }],
        },
        subscription: {
          plan: {
            allowedFeatures: [],
            blockedFeatures: [],
          },
        },
      },
      donation: {
        isMatchAvailable: false,
        matched: 0,
        donated: 0,
        maxPerEmployee: 0,
        matchExpiryDate: null,
      },
      giftOfGiving: null,
      nonProfitCompany: {
        id: -1,
      },
      location: null,
      raised: 0,
      volunteeringHrs: 0,
      goodsDonated: 0,
      topTeamMembers: [],
      selectedProfile: 'org',
    },
    roles: [],
    isNekiAdmin: false,
    isCompanyAdmin: false,
    isNonProfitAdmin: false,
    isNonProfitUser: false,
    isCompanyUser: false,
    isFollowing: (userId) =>
      get().user.profile.following.influencers.includes(userId),
  },
});

export default createUserSlice;
